import {connect} from 'react-redux';
import { getRoles } from '../api/copy';
import {toggleModal} from '../redux/modals.js';
import Home from '../components/pages/Home/Home.jsx';

function mapStateToProps({token, locale, data, ui}) {
  return {
    token,
    dealerInfo: data.get('dealerInfo').toJS(),
    roles: locale.get('roles'),
    locale: locale.get('locale'),
    truBlueDates: data.get('truBlueDates'),
    disclaimerModalVisible: ui.getIn(['modals', 'disclaimer']),
    privacyModalVisible: ui.getIn(['modals', 'privacy']),
  };
}

const toggleDisclaimerModal = toggleModal.bind(null, 'disclaimer');
const togglePrivacyModal = toggleModal.bind(null, 'privacy');

function mapDispatchToProps(dispatch) {
  return {
    getRoles: () => dispatch(getRoles()),
    toggleDisclaimerModal: (value) => dispatch(toggleDisclaimerModal(value)),
    togglePrivacyModal: (value) => dispatch(togglePrivacyModal(value)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
